module.exports = __webpack_public_path__ + "files/c53079e87cee487b72404af42eba464f.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/roboto-italic-webfont.woff2
// module id = 916
// module chunks = 60